import React from "react";
import web1 from "../../../image/portfolio-images/web.PNG"
import p2 from "../../../image/portfolio-images/p2.PNG"
import nemo from "../../../image/portfolio-images/nemo.PNG"
const Website = () => {

  return (
    <div
    
      data-aos="fade-right"
      data-aos-offset="300"
      data-aos-easing="ease-in-sine"
      data-aos-duration="1000"
    >
      <div className="my-16 lg:mx-20 pt-20">
        <h3>Stylish & Flexible</h3>
        <h1 className="text-6xl text-white">Explore Demos</h1>
        <div class="max-w-7xl mx-auto">
          <div class="max-w-2xl mx-auto sm:py-24 lg:max-w-none">
 

            <div class="mt-6 space-y-12 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-x-6">
              <div class="group relative">
                <div class="relative w-full h-80 bg-white rounded-lg overflow-hidden group-hover:opacity-75 sm:aspect-w-2 sm:aspect-h-1 sm:h-64 lg:aspect-w-1 lg:aspect-h-1">
                  <img
                    src={web1}
                    alt=""
                    class="w-full h-full object-center object-cover"
                  />
                </div>
                <h3 class="mt-6 text-sm text-gray-500">
                  <a href="https://jez-salad.web.app/">
                    <span class="absolute inset-0"></span>
                  Resturent Website
                  </a>
                </h3>
                <p class="text-base font-semibold text-white">
                JEZ SALAD
                </p>
              </div>

              <div class="group relative">
                <div class="relative w-full h-80 bg-white rounded-lg overflow-hidden group-hover:opacity-75 sm:aspect-w-2 sm:aspect-h-1 sm:h-64 lg:aspect-w-1 lg:aspect-h-1">
                  <img
                    src={p2}
                    alt="Wood table with porcelain mug, leather journal, brass pen, leather key ring,
              and a houseplant."
                    class="w-full h-full object-center object-cover"
                  />
                </div>
                <h3 class="mt-6 text-sm text-gray-500">
                  <a href="https://md-ashikur.github.io/Personal-profile-design/">
                    <span class="absolute inset-0"></span>
                   Single page website
                  </a>
                </h3>
                <p class="text-base font-semibold text-white">
                  Personal Portfolio
                </p>
              </div>

              <div class="group relative">
                <div class="relative w-full h-80 bg-white rounded-lg overflow-hidden group-hover:opacity-75 sm:aspect-w-2 sm:aspect-h-1 sm:h-64 lg:aspect-w-1 lg:aspect-h-1">
                  <img
                    src={nemo}
                    alt=""
                    class="w-full h-full object-center object-cover"
                  />
                </div>
                <h3 class="mt-6 text-sm text-gray-500">
                  <a href="https://md-ashikur.github.io/nemo/index.html">
                    <span class="absolute inset-0"></span>
                    Company Website
                  </a>
                </h3>
                <p class="text-base font-semibold">
                NEMO
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Website;
